import request from '@core/services/request';

export const saturnBrowserAPI = {
	download: (entity: any) => request.download(`/SaturnDesktop/DownloadApp?user=${entity}`, entity === 'Staff' ? 'SaturnDMS.exe' : 'Customer-SaturnDMS.exe'),
	connectToSaturnBrowser: () => request.getSB('/ConnectToSaturnBrowser'),
};
